// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"31918431226cb3c0","261":"0c3f0e785ce511b7","533":"24f76d5e7226a8c1","922":"b542acf172080464"}[chunkId] + ".js";
};